<template>
  <wizard-wrap
      @next-step="nextStep"
      @last-step="lastStep"
      class="pt-xl pb-xl"
      :active-step="wizard.activeStep"
      :total-steps="wizard.totalSteps"
      :next-step-label="getNextStepLabel"
      :wizard-step-size="wizard.steps[wizard.activeStep].size"
      :preloader="!order || !order.Order"
      :btn-loader="loading">

    <template v-if="order.Order">
      <h2 slot="wizard-title" class="flex justify-between align-center pb-s">
        <span>{{localize('new_mguide_order')}}</span>
        <a v-if="mode === 'create' || order.Order.IsDraft" @click.prevent="submit(true)"
          href="#p" class="btn btn-primary-outline rounded" >{{localize('Save Draft')}}</a
        >
      </h2>
      <wizard-nav
        class="py-2xl"
        slot="wizard-nav"
        :locale="locale"
        :mode="mode"
        :steps="wizard.steps"
        :valid-step="formIsValid"
        :active-step="wizard.activeStep"
        :total-steps="wizard.totalSteps"
        @step-clicked="stepCallback"
      ></wizard-nav>      
      <div
        slot="wizard-steps"
        class="wizard-active-step pt-xl pb-s"
        :class="[
          wizard.steps[wizard.activeStep].size
            ? 'container__' + wizard.steps[wizard.activeStep].size
            : 'container'
        ]"
      >
        <p v-if="wizard.activeStep < 4" class="note required-fields-note">
          * {{localize('req_field')}}
        </p>

        <transition name="fade-slide" mode="out-in" appear>

          <div key="wizard-step-0" v-if="wizard.activeStep === 0" :class="['flex-split',locale=='HE' ? 'rtl':'']" >
            <div>
              <div>
                <h4 class="text-blue font-rg">{{localize('general_info')}}</h4>
                <div class="form-field flex">
                <label :class="['strong',locale=='HE' ? 'rtl':'']" v-text="(isClinic ? localize('Clinic') : localize('Doctor')) + ':'"></label>
                  <span
                    v-text="
                      isClinic
                        ? getClinicName
                        : getDoctorName
                    "
                  ></span>
                </div>
                <div v-if="isClinic" class="form-field flex align-center">
                  <label class="strong">{{localize('dentist')}}:</label>
                  <form-field
                    :locale="locale"
                    class="mb-0"
                    field-type="select"
                    :select-options="dentistList"
                    v-bind:select-placeholder="localize('pick_dentist')"
                    v-model.number="order.Order.ClinicDoctorID"
                    multi
                    rounded
                  ></form-field>
                </div>
              </div>
            </div>
            <div class="rel">


              <h4 class="text-blue font-rg">{{localize('case_info')}}</h4>
              <div class="form-field flex flex-wrap rel mb-0">
                <label class="strong flex-full mb-s"
                  >{{localize('patient_identification')}} *</label
                >
                <fragmented-field
                  :frags="patientIdFragments"
                  v-model="order.Order.Cust_name"
                  :dirty="solicitNextStep"
                  @validate-field="updateValidHash"
                ></fragmented-field>
                <err-msg 
                  v-if="isInvalid('patientId')"
                  :msg="localize('this_fileld_required')"></err-msg>


              </div>
              <p class="note text-gray-6 mt-m ml-xs">                
                {{localize('patient_identification_instructions')}}
                <!--
                Patient Identification Patient ID MUST be written in this
                format:
                <strong class="text-gray-7">
                  first name initials, last name initials, date of birth
                  (DD/MM/YYYY). Ex: OK23081975
                </strong>
                -->
              </p>
              <div class="form-field flex-column pt-l">
                <label class="strong flex-full mb-m"
                  >{{localize('planned_surgery_date')}}</label>
<!--                  <form-field
                  v-bind:label="localize('pick_date')"
                  field-type="date"
                  v-model="order.Order.Actual_implant_date"
                  rounded
                  icon="calendar-alt"
                  icon-color="text-blue-4"
                  :pikaday-more-options="{minDate: minImplantDate}"
                  :err="validHash['Pick Date'] === false"
                  :dirty="solicitNextStep"
                  :err-msg="localize('this_fileld_required')"
                  @validate-field="updateValidHash"
                  label-is-placeholder
                  req
                ></form-field> -->
                
                <form-field
                  v-bind:label="localize('pick_date')"
                  field-type="date"
                  v-model="order.Order.Actual_implant_date"
                  rounded
                  icon="calendar-alt"
                  icon-color="text-blue-4"
                  :pikaday-more-options="{minDate: minImplantDate}"
                  :dirty="solicitNextStep"
                  :locale="locale"
                  label-is-placeholder
                ></form-field>
                
              </div>
              <div class="form-field flex-column pt-xl">
                <label class="strong flex-full mb-m"
                  >
                  {{localize('order_title')}} ({{localize('Optional')}}):
                  </label
                >
                <form-field
                  class="mb-0"
                  v-bind:label="localize('enter_text')"
                  v-model="order.Order.Order_header"
                  full-width
                  rounded
                  label-is-placeholder
                  :maxlength="36"
                  :locale="locale"
                ></form-field>
                <p class="note text-gray-6 mt-m mx-xs">
                  {{localize('for_example_your_patientid')}}
                </p>
              </div>
            </div>
          </div>
          <div
            key="wizard-step-1"
            v-else-if="wizard.activeStep === 1"
            class="flex-split"
          >
            <div>
              <div class="rel mb-xl">
                <h4 class="text-blue font-rg mb-0">{{localize('clinical_indications')}}</h4>
                <p class="font-lt">
                  {{localize('please_indicate_tooth')}}                  
                </p>
                <err-msg
                  :msg="localize('please_select_at_least_one_implant_site')"
                  v-if="isInvalid('teethChart')"
                ></err-msg>
                <teeth-chart
                  :method="order.Order.IndicationsMethod"
                  :selected-data="teeth.selected"
                  @method-updated="updateMethod"
                  @tooth-update="toothUpdated"
                  @validate-chart="updateValidHash"
                  :dirty="solicitNextStep"
                ></teeth-chart>
              </div>
            </div>
            <div>
              <h4 class="text-blue font-rg">{{localize('implant_location')}}</h4>
              <template v-if="selectedTeethForImplant.length">
                <div v-for="(tooth, i) in teeth.selected" :key="tooth.id">
                  <field-group
                    :locale="locale" 
                    :disabled="tooth.opt === 1"
                    @copy-to-all="
                      pasteDataToAll($event, order.ImplantLocations)
                    "
                    :count="selectedTeethForImplant.length"
                    :tooth-method-number="
                      tooth[order.Order.IndicationsMethod === 1 ? 'ADA' : 'FDI']
                    "
                    :tooth-data="parseToothNumber(tooth)"
                    :group-index="i"
                    :fields="
                      fetchImplantLocationFields(order.ImplantLocations[i])
                    "
                    :value="order.ImplantLocations[i]"
                    @input="
                      updateImplantLocations($event, arguments[0], tooth, i)
                    "
                    @update-valid-hash="updateValidHash"
                    @remove-validation="removeFromValidHash"
                    :dirty-fields="solicitNextStep"
                  ></field-group>
                </div>
              </template>
              <p class="emphasized mb-l" v-else>{{localize('no_tooth_selected')}}</p>
              <div class="mt-3xl mb-xl flex" style="column-gap: 40px;">
                <div class="rel pb-xl pr-xl">
                  <h5 class="font-bd text-gray-7 mb-m">
                    {{localize('procedure_type')}}
                  </h5>
                  <div :class="['radio-group',locale=='HE' ? 'rtl' :'']">
                    <label
                      :key="item.id"
                      v-for="item in orderOptions.AdditionalIndicationsTypes"
                      class="mb-s"
                      :for="item.name"
                    >
                      <input
                        v-model="order.Order.AdditionalIndicationsTypeID"
                        :value="item.id"
                        type="radio"
                        name="indications"
                        :id="item.name"
                        @input="updateValidHash('AdditionalIndicationsTypeID', true)"
                      />
                      <span v-text="localize(item.name)"></span>
                    </label>
                  </div>
                  <err-msg
                    :msg="localize('selection_is_required')"
                    v-if="isInvalid('AdditionalIndicationsTypeID')"
                  ></err-msg>
                </div>
                <div class="ml-2xl rel pb-xl">
                  <h5 class="font-bd text-gray-7 mb-m">
                    {{localize('support_type')}}
                  </h5>
                  <div :class="['radio-group',locale=='HE' ? 'rtl' :'']">

                    <label
                      :key="item.id"
                      v-for="item in supportTypes"
                      class="mb-s"
                      :for="item.name"
                    >
                      <input
                        v-model="order.Order.MguideSupportType"
                        :value="item.id"
                        type="radio"
                        name="support"
                        :id="item.name"
                        @input="updateValidHash('MguideSupportType', true)"
                      />
                      <span v-text="localize(item.name)"></span>
                    </label>

                    <!-- Fixation Pins -->
                    <div :class="['check-group fixation', locale=='HE' ? 'rtl':'']">
                      <form-field class="flex mb-0"
                        :locale="locale"
                        field-type="checkbox"
                        v-bind:label="localize('Fixation Pins')"
                        v-model="order.Order.FixationPins"
                        external-label
                      ></form-field>                    
                    </div>
                    <!-- Fixation Pins -->

                  </div>
                  <err-msg
                    :msg="localize('selection_is_required')"
                    v-if="isInvalid('MguideSupportType')"
                  ></err-msg>
                </div>
              </div>

              <div class="mt-3xl mb-xl">
                <h5 class="font-bd text-gray-7 mb-m">
                  {{localize('planned_prosthtic_otpions')}}
                </h5>
                <div
                  v-if="order.OrderProstheticSolutionIDs"
                  <div :class="['check-group row', locale=='HE' ? 'rtl':'']"
                >
                  <label
                    v-for="option in orderOptions.ProstheticSolutionTypes"
                    :key="option.id"
                    class=""
                  >
                    <input
                      @input="updateProstheticSolutionIDs(option)"
                      :value="option.id"
                      type="checkbox"
                      name="prostheticOptions"
                      :checked="solutionIndex(option) > -1"
                    />
                    <span v-text="localize(option.name)"></span>
                  </label>
                </div>
              </div>

              <!-- USE CORE FILE CHECKBOX -->
              <div :class="['checkbox',locale=='HE' ? 'rtl' : '']">
               <label for="cbCoreFile">
                  <div class="coreFileCheck">
                    <input v-model="order.Order.UseCoreFile" type="checkbox" id="cbCoreFile"/>
                  </div>
                  <div class="coreFileText">
                      <span class="useCoreFileText" 
                        v-html="localize('in_case_of_immediate_loading_planning')+': '+localize('add_core_file_option')"></span>
                      <i @click.prevent="openCoreFileInfo"
                      style="color:#0076c0;cursor:pointer;margin:0px 5px;position:relative;" 
                      class="fas fa-exclamation-circle">
                        <div :class="['CoreFileInfo',isCoreFileInfoOpen ? 'open':'']">
                          <i class="fas fa-times"></i>
                          {{localize('core_file_information')}}
                        </div>
                      </i>
                  </div>
                  <!-- add_core_file_option = In case of immediate loading planning: Please add an <b>MGUIDE Core file</b> to my order. -->                  
                </label>
                

              </div>

            </div>
          </div>


          <!-- WIZARD STEP 2 
            todo: if pro-order is checked do not make the files section mandatory 
          -->

          <div key="wizard-step-2" v-if="wizard.activeStep === 2">
            <!-- *******************************************************************-->
            <!-- *******************************************************************-->
            <!-- *************  PRO/FULL SERVICE ORDER SELECTOR  *******************-->
            <!-- *******************************************************************-->
            <!-- *******************************************************************-->            
            <!-- Pro Order Limitation of Liability content -->
            <div class="ProLiabilityInfo" v-if="ProLiabilityInfoOpen">
              <div @click="ProLiabilityInfoOpen=false" class="xClose"><i class="fal fa-times"></i></div>
              <div class="InnerText">
                {{localize('disclamer_1')}}<!-- MIS/Dentsply Sirona is liable as a supplier of products... -->
              </div>
            </div>        

            <!-- debug values     
            <div style="color:red;font-size:20px;">
              orderUser.IsProUser={{orderUser.IsProUser}}
              <br/>
              order.Order.IsProOrder={{order.Order.IsProOrder}}
              <br/>
              wizard.activeStep={{wizard.activeStep}}
              <br/>
              orderPlan={{orderPlan}}
              <br/>
              proCheck1={{proCheck1}}
              <br/>
              proCheck2={{proCheck2}}
              <br/>
            </div>-->


            <div class="planSelector" v-if="orderUser.IsProUser==true">
                <table :class="['planGrid',orderPlan==1 ? 'plan1' : '',orderPlan==2 ? 'plan2' : '']">
                    <tr>
                        <td class="plFeatureName plTransCell">
                          {{localize('selec_order_option')}}
                        </td>
                        <td style="font-weight:500;">PRO</td>
                        <td style="font-weight:500;">{{localize('full_service')}}</td>
                    </tr>
                    <tr>
                        <td class="plFeatureName">
                          {{localize('implant_positioning_mcenter')}}
                        </td>
                        <td></td>
                        <td><i class="fal fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="plFeatureName">
                          {{localize('surgical_plan_review')}}
                        </td>
                        <td></td>
                        <td><i class="fal fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="plFeatureName">{{localize('template_design_by_mcenter')}}</td>
                        <td><i class="fal fa-check"></i></td>
                        <td><i class="fal fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="plFeatureName">
                          {{localize('template_manufacturing_by_mcenter')}}
                        </td>
                        <td><i class="fal fa-check"></i></td>
                        <td><i class="fal fa-check"></i></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td class="plan1Select">
                          <a @click="orderPlan=1;order.Order.IsProOrder=true;" class="btn btn-primary-outline rounded btnSelectPlan">
                          {{localize('select')}}</a></td>
                        <td class="plan2Select"><a @click="orderPlan=2;order.Order.IsProOrder=false;" class="btn btn-primary-outline rounded btnSelectPlan">
                          {{localize('select')}}</a></td>
                    </tr>
                </table>

                
                <div class="proOrderInfo" v-if="orderPlan==1">
                    <span>{{localize('share_surgical_plan_via_msoft_with_mcenter')}}</span>
                    <br/>
                    <form-field
                      :locale="locale"
                      class="mb-0 msoft_input"
                      v-bind:label="localize('msoft_case_no')"
                      v-model="order.Order.MSOFT_CASE_NO"
                      full-width
                      rounded
                      label-is-placeholder
                      :maxlength="10"
                    ></form-field>
                    <!--
                      xxxxx
                    <span>{{localize('share_surgical_plan_via_msoft')}}</span>
                    <ul>
                      <li>{{localize('for_eu')}}</li>
                      <li>{{localize('for_us')}}</li>
                      <li>{{localize('for_wow')}}</li>
                    </ul>                  
                    -->
                </div>

                <div :class="['proOrderNotes',proOrderNotesValid ===true? '':'boxErr']" v-if="orderPlan==1">
                  <div style="font-weight:400;margin-bottom: 15px;">
                    {{localize('limitation_of_liability')}}
                  </div>
                  <div class="cbItem">
                    <input type="checkbox" v-model="proCheck1">
                    <p @click="proCheck1=!proCheck1">{{localize('i_hereby_confirm1')}}</p>
                  </div>
                  <div class="cbItem">
                    <input type="checkbox" v-model="proCheck2">
                    <p @click="proCheck2=!proCheck2">{{localize('i_hereby_confirm2')}}&nbsp;<i @click="ProLiabilityInfoOpen=true" title="More info" style="color:#0076c0;cursor:pointer;" class="fas fa-exclamation-circle"></i>
                    </p>
                  </div>
                  <!--
                      MIS/Dentsply Sirona is liable as a supplier of products. Since the circumstances in which these products are ordered and used are under control of the buyer, the latter recognizes his responsibility for these circumstances. On these grounds the remedies of the buyer are limited as follows:
                      The liability of MIS/Dentsply Sirona for real and proven damages will, regardless of the gravity of the failure, except in case of fraud, be limited to the price of the product directly related to the reason of claim. Under no circumstances an indemnity can be grounded on indirect damages such as, but not limited to, loss of revenue, increase of expenses, disturbance of planning, loss of customers or goodwill, loss of benefits or expected savings or any other financial or commercial losses which are not a direct and immediate consequence of a shortcoming of MIS/Dentsply Sirona in its obligations. Buyer agrees to control the conformity of any delivered product with his order, before using it. Should buyer omit to perform such control or decide to nevertheless use a non-conformable product, he frees MIS/Dentsply Sirona from any liability for the consequences of the use of such product.
                      The client hereby represents and warrants that he has requested and received the duty informed consent of the patient to use its private and medical information during the ordering and delivery process of the MGUIDE, in compliance with all applicable laws, including any applicable privacy regulations.
                    -->
                </div>
            </div>
            <!-- ******************************* PRO/FULL SERVICE ORDER SELECTOR -->            
          
          <!------------------------------------ pro order ---------------------------------->
          <!--
          <div>
              
              <div class="check-group" style="padding-bottom:40px;" v-if="!orderUser.isProUser">
                <form-field 
                  class="flex mb-0" 
                  field-type="checkbox" 
                  label="Pro Order" v-model="order.Order.IsProOrder" 
                  external-label></form-field>
                <div class="bg-gray-2 p-m note br-2">
                  <b style="font-weight:500;">Check the 'Pro Order' box if you wish to:</b>
                  <ul class="ProOrderTerms">
                    <li>Plan and approve a surgical plan by yourself without consulting the MCENTER (Experienced MSOFT user).</li>
                    <li>Review, correct, and approve the MCENTER's suggested surgical plan by yourself without consulting the MCENTER.</li>
                  </ul>
                </div>
              </div>
          </div>-->

          <!-- <div class="flex-split mvh-40" 
              v-if="!order.Order.IsProOrder"> -->
              <!--
<div :class="['flex-split mvh-40',order.Order.IsProOrder ? 'hiddenSection' : '']" >                          
                -->          
          <div 
          :class="['flex-split mvh-40',
                  orderPlan==2 || orderUser.IsProUser!=true  ? '' : 'hiddenSection']" >                    
            <div class="rel">
              <h4 class="text-blue font-rg">{{localize('upload_data')}}</h4>
              <h5>{{localize('information_sources')}}</h5>
              
              <!-- order.MediaFiles={{order.MediaFiles}} -->
              <div :class="['check-group flex flex-row',locale=='HE' ? 'rtl':'']">
                <label for="digital">
                  <input
                    v-model="teeth.hasDigital"
                    type="checkbox"
                    id="digital"
                  />
                  <span>{{localize('digital_file')}}</span>
                </label>
                <label class="mb-s" for="models">
                  <input
                    v-model="teeth.hasStoneModel"
                    type="checkbox"
                    id="models"
                  />
                  <span>{{localize('stone_models')}}</span>
                </label>

                <!--
                <label class="mb-s" for="impressions" v-if="orderUser.McenterID===9">
                  <input
                    v-model="teeth.hasImpressions"
                    type="checkbox"
                    id="impressions"
                  />
                  <span>Impressions</span>                  
                </label>
                -->

                <label v-if="isUSA || isIsrael" class="mb-s" for="third-party">
                  <input
                    v-model="teeth.has3rdParty"
                    type="checkbox"
                    id="third-party"
                  />
                  <span>{{localize('3rd_party')}}</span>
                </label>
              </div>

              <err-msg
                class="mt-xl"
                :msg="localize('selection_is_required')"
                v-if="isInvalid('uploadCheck')"
              ></err-msg>

              <transition name="fade" appear>
                <div class="mt-2xl" v-if="teeth.hasDigital">
                  <h5 class="mb-s">
                    {{localize('upload_cbct')}}
                    <!--Upload <strong>CBCT</strong> files .zip or .rar format *-->
                  </h5>
                  <keep-alive>
                    <uploader
                      name="upload-cbct"
                      @update-media-files="updateMediaFiles"
                      @remove-media-file="removeMediaFile"
                      :dirty="solicitNextStep"
                      :will-validate="!hasCBCTFile"
                      :locale = "locale"
                      @validate-field="updateValidHash"
                      @remove-validation="removeFromValidHash"
                      accepted-file-types=".rar,application/x-rar-compressed, application/pdf, application/zip,application/rar, application/x-zip-compressed, application/vnd.rar, application/octet-stream"
                      req
                      class="mb-xl"
                    ></uploader>
                  </keep-alive>

                  <div class="pl-l">
                    <a
                      href="https://www.youtube.com/watch?v=jOkBdyC73As"
                      target="_blank"
                      class="note"
                    >
                      <i class="fal fa-play-circle mr-xs"></i>
                      <span>{{localize('how_to_create_zip')}}</span>
                    </a>
                    <p class="mt-s note">
                      <a
                        target="_blank"
                        href="https://www.mis-implants.com/upload/pdf/products/MCENTER/MGUIDE_CBCT_Guidelines.pdf"
                        >{{localize('click_here')}}</a
                      >
                      {{localize('for_MGUIDE_protocol_for_CBCT')}}
                    </p>
                  </div>
                  <h5 class="mt-xl mb-s">{{localize('upload_scan_files')}}</h5>
                  <!-- Upload <strong>scan files</strong> in .stl format -->                  
                  <keep-alive>
                    <uploader
                      name="upload-stl"
                      @remove-media-file="removeMediaFile"
                      :dirty="solicitNextStep"
                      :locale = "locale"
                      :will-validate="
                          !teeth.hasStoneModel &&
                          !teeth.hasImpressions &&
                          !teeth.has3rdParty &&
                          !hasStlFile
                      "
                      @validate-field="updateValidHash"
                      @remove-validation="removeFromValidHash"
                      @update-media-files="updateMediaFiles"
                    ></uploader>
                  </keep-alive>
                  <div v-if="hasMediaFiles" class="files-list mt-xl">
                    <h5 class="font-bd mb-m">{{localize('files_uploaded')}}:</h5>
                    <!-- //////////////////////////////////////////////////////////////// -->
                    <!-- /// DOWNLOAD/REMOVE FILES FROM ORDER {{order.MediaFiles}} ///// -->
                    <!-- //////////////////////////////////////////////////////////////// -->    
                    <div v-if="hasBlockedFiles" class="blockedFilesNote">
                      Please see below blocked files (red)
                    </div>
                    <ul class="filesItems">
                      <li :class="['flex align-center mb-s','process_type_'+file.FileProccessingTypeId]"
                        v-for="file in order.MediaFiles" :key="file.FileName">
                          
                          <span class="blockedFile" v-if="file.FileProccessingTypeId==2">
                            <!-- blocked file -->
                            <i class="fal fa-file-exclamation mr-xs"></i>&nbsp;&nbsp;                            
                            <span v-text="file.OriginFileName"></span> 
                          </span>
                          <span v-else-if="file.FileProccessingTypeId==-1">
                            <!-- added file -->
                            <i class="fal fa-file mr-xs"></i>&nbsp;&nbsp;                            
                            <span v-text="file.OriginFileName"></span> 
                          </span>
                          <a v-else :title="file.OriginFileName" :href="getFileLink(file)">                            
                            <!-- ok file (can be downloaded) -->
                            <i class="fal fa-file-check mr-xs"></i>&nbsp;&nbsp;                            
                            <span v-text="file.OriginFileName"></span> 
                          </a>
                          <span class="removeFile" title="Remove file">
                            <i @click="removeMediaFile(file.OriginFileName)" class="fal fa-times ml-xs"></i>
                          </span>                         
                          
                        
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>
            <div class="form-part mt-xl">
              <div class="rel pb-m mb-xl pr-xl" v-if="teeth.has3rdParty">
                <h5 class="font-bd text-gray-7 mb-m">
                  <span>{{localize('3rd_party')}}:</span>
                </h5>
                <div :class="['rel radio-group',locale=='HE' ? 'rtl' :'']">
                  <label
                    v-for="item in orderOptions.File3RdPartyTypes"
                    class="mb-s"
                    :key="item.File3RdPartyID"
                    :for="'3rdparty' + item.File3RdPartyID"
                  >
                    <input
                      v-model="order.Order.File3dTypeID"
                      :value="item.File3RdPartyID"
                      type="radio"
                      name="indications"
                      :id="'3rdparty' + item.File3RdPartyID"
                      @input="updateValidHash('File3dTypeID', true)"
                    />
                    <span v-html="item.File3RdPartyType1"></span>
                  </label>
                </div>
                <err-msg
                  :msg="localize('selection_is_required')"
                  v-if="isInvalid('File3dTypeID')"
                ></err-msg>
              </div>
              <!-- Tracking number -->
              <form-field
                :locale="locale"
                v-if="teeth.hasStoneModel"
                v-bind:label="localize('add_stone_model_tracking_no')"
                v-model="order.Order.MlabStoneModelTrackingNumber"
                :dirty="solicitNextStep"
                @validate-field="updateValidHash"
                @remove-validation="removeFromValidHash"
                rounded
                req
              ></form-field>
              <form-field
                v-if="teeth.hasImpressions"
                v-bind:label="localize('add_impression_tracking_no')"
                v-model="order.Order.MlabImpressionTrackingNumber"
                :dirty="solicitNextStep"
                @validate-field="updateValidHash"
                @remove-validation="removeFromValidHash"
                rounded
                req
              ></form-field>
              <transition name="fade" appear>
                <p class="note my-s" v-if="teeth.hasStoneModel || teeth.hasImpressions">
                  {{localize('when_sending_non_digital')}}
                </p>
              </transition>
            </div>
          </div>
          </div>

          <!-- WIZARD STEP 2 END -->
          <div
            key="wizard-step-3"
            v-else-if="wizard.activeStep === 3"
            class="flex-split mvh-40"
          >
            <div>
              <!-- SurgicalSetTypes -->
              <h4 class="text-blue font-rg">{{localize('surgical_sets_available')}}</h4>
              <div class="SurgicalSetTypes">
               <label v-for="setOption in orderOptions.SurgicalSetTypes" 
                :key="setOption.Id" 
                :for="'set_' + setOption.Id">
                <input                  
                  @input="updateSurgicalSetTypeIDs(setOption.Id)"
                  :checked="findSetIndex(setOption.Id) > -1"
                  :value="setOption.Id"                  
                  type="checkbox" 
                  :id = "'set_' + setOption.Id"/>
                <b><span class="bold" v-text="setOption.CatNo"></span></b> - 
                <span v-text="setOption.SetName"></span>
                </label>
              </div>
              <!-- :checked="findSetIndex(setOption.Id) > -1"  -->

              <h4 class="text-blue font-rg">{{localize('additional_notes')}}</h4>
              <form-field
                :locale="locale"
                class="stretch"
                field-type="textarea"
                v-bind:label="localize('write_your_comments')"
                v-model="order.Order.comment"
                rounded
                label-is-placeholder
              ></form-field>
            </div>
            <div class="mt-s">
              <h5 class="mb-0 pb-xs font-bd">{{localize('mis_warranty')}}</h5>
              <p class="note mb-l text-gray-7">
                {{localize('mis_exercises')}}<!-- MIS exercises great care and effort in maintaining the superior quality of its products. All MIS products are guaranteed to be free from defects in material and workmanship. However, should a customer find fault with any MIS product after using it according to the directions, the defective product will be replaced. -->
              </p>
              <h5 class="mb-0 pb-xs font-bd">
                {{localize('liability')}}
              </h5>
              <p class="note text-gray-7">
                {{localize('liability_desc1')}}
                <br/>
                <a style="cursor:pointer;" v-if="LiabilityExpandText===false" @click="LiabilityExpandText=true">
                  {{localize('read_more')}}...</a>
                <p class="note text-gray-7" v-if="LiabilityExpandText===true">
                  <br/>{{localize('liability_desc2')}}
                  <br/><br/>{{localize('liability_desc3')}}
                </p>
                <a style="cursor:pointer;" v-if="LiabilityExpandText===true" @click="LiabilityExpandText=false">
                  {{localize('less')}}...</a>
              </p>
            </div>
          </div>
          <div
            key="wizard-step-4"
            v-else-if="wizard.activeStep === 4"
            :class="['mvh-40','wiz-review',locale=='HE' ? 'rtl':'']"
          >
            <h3>
              <strong>{{localize('order_review')}}</strong>
              <!--              
              <span
                v-if="order.Order.Order_header"
                v-text="' - ' + order.Order.Order_header"
              ></span>-->
              <span class="text-blue note" v-if="order.Order.IsProOrder"
                >*{{localize('pro_order')}}</span
              >
            </h3>

            <div class="flex-split">
              <div>
                <div class="mb-xl">
                  <h4 class="text-blue font-rg mb-m">{{localize('general_info')}}</h4>
                  <div :class="['review-field',getLangDir]">
                    <span v-text="isClinic ? localize('Clinic') : localize('Doctor') + ':'"></span>
                    <span
                      v-text="
                        isClinic
                          ? `${orderUser.ClinicName} (${orderUser.ClinicBranch})`
                          : `${orderUser.FirstName} ${orderUser.LastName}`
                      "
                    ></span>
                  </div>
                </div>
                <div>
                  <h4 class="text-blue font-rg">{{localize('case_info')}}</h4>                  
                  <div v-if="order.Order.Order_header" :class="['review-field',getLangDir]">
                    <span>{{localize('order_title')}}:</span>
                    <span v-text="order.Order.Order_header"></span>
                  </div>
                  <div v-if="order.Order.Cust_name" :class="['review-field',getLangDir]">
                    <span>{{localize('Patient identification')}}:</span>
                    <span v-text="order.Order.Cust_name"></span>
                  </div>
                  <div v-if="order.Order.Order_date" :class="['review-field',getLangDir]">
                    <span>{{localize('order_creation_date')}}:</span>
                    <span v-text="formatDate(order.Order.Order_date)"></span>
                  </div>
                  <div
                    v-if="order.Order.Actual_implant_date" :class="['review-field',getLangDir]">
                    <span>{{localize('planned_surgery_date')}}:</span>
                    <span v-text="formatDate(order.Order.Actual_implant_date)"></span>
                  </div>
                  <div
                    v-if="order.Order.MlabStoneModelTrackingNumber"
                    :class="['review-field',getLangDir]"
                  >
                    <span>{{localize('stone_model_tracking_no')}}:</span>
                    <span
                      v-text="order.Order.MlabStoneModelTrackingNumber"
                    ></span>
                  </div>
                  <div
                    v-if="order.Order.MlabImpressionTrackingNumber"
                    :class="['review-field',getLangDir]"
                  >
                    <!--<span>Impression tracking No.:</span>-->
                    <span>{{localize('imp_tracking_no')}}:</span>
                    <span
                      v-text="order.Order.MlabImpressionTrackingNumber"
                    ></span>
                  </div>
                  <div v-if="order.Order.File3dTypeID" :class="['review-field',getLangDir]">
                    <span>{{localize('3rd_party')}}:</span>
                    <!-- fetchLabel(id, list, label = "name") { -->
                    <span
                      v-html="
                        fetchLabel(
                          order.Order.File3dTypeID,
                          orderOptions.File3RdPartyTypes,
                          'File3RdPartyType1',
                          'File3RdPartyID'
                        )
                      "
                    ></span>
                  </div>

                  <!-- Msoft case number -->
                  <div v-if="order.Order.MSOFT_CASE_NO && order.Order.MSOFT_CASE_NO.length>0" class="review-field">
                    <span>{{localize('msoft_case_no')}}:</span>
                    <span v-text="order.Order.MSOFT_CASE_NO"></span>
                  </div>
                  <!-- Core File -->
                  <div class="review-field corefile" v-if="isUseCoreFile">
                    <span v-html="localize('add_core_file_option')"></span>
                  </div>
                  <!-- Surgical kits -->
                  <div class="review-field" v-if="tmpSurgicalSetsNos.length>0">
                    <span>{{localize('surgical_sets_available')}}:</span>
                    <span v-text="tmpSurgicalSetsNos"></span>
                  </div>

                  <!-- add here 
                  order.Order.UseCoreFile
                  Msoft case number
                  Core file
                  Surgical kits                      
                  -->


                  <div class="review-field" v-if="order.Order.comment">
                    <span>{{localize('additional_notes')}}:</span>
                    <span v-text="order.Order.comment"></span>
                  </div>
                  <div v-if="hasMediaFiles" class="review-field files-list">
                    <span class="mb-m">{{localize('files_uploaded')}}:</span>
                    <ul>
                      <li
                        class="flex align-center"
                        v-for="file in order.MediaFiles"
                        :key="file.FileName"
                      >
                        <a
                          :title="file.OriginFileName"
                          href="#p"
                          @click.prevent=""
                        >
                          <i class="fal fa-file mr-xs"></i>
                          <span v-text="file.OriginFileName"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="mb-xl" v-if="teeth.selected.length">
                <teeth-chart
                  :method="order.Order.IndicationsMethod"
                  :selected-data="teeth.selected"
                  display-mode
                ></teeth-chart>
                <h4 class="text-blue font-rg mt-xl">{{localize('clinical_indications')}}</h4>
                <!-- bug here not displaying teeth list -->
                <!-- bug here not displaying teeth list -->
                <!-- bug here not displaying teeth list -->
                <!-- bug here not displaying teeth list -->
                <!-- bug here not displaying teeth list -->
                
                <div v-for="(tooth, i) in teeth.selected" :key="tooth.id">
                  <!-- v-show="tooth.opt !== 1" -->

                  <field-group
                    :disabled="tooth.opt === 1"
                    :count="teeth.selected.length"                    
                    :tooth-data="parseToothNumber(tooth)"
                    :tooth-method-number="tooth[order.Order.IndicationsMethod === 1 ? 'ADA' : 'FDI']"
                    :group-index="i"
                    :fields="fetchImplantLocationFields(order.ImplantLocations[i])"
                    :value="order.ImplantLocations[i]"
                    display-mode
                  ></field-group>

                  <!--
                  <field-group
                    :key="tooth.id"
                    :count="teeth.selected.length"
                    :group-index="i"
                    :tooth-data="parseToothNumber(tooth)"
                    :fields="[]"
                    :value="order.ImplantLocations[i]"
                    display-mode
                  ></field-group>
                  -->

                </div>
                <div class="review-field">
                  <span>{{localize('procedure_type')}}: </span>
                  <span
                    v-text="
                      fetchLabel(
                        order.Order.AdditionalIndicationsTypeID,
                        orderOptions.AdditionalIndicationsTypes
                      )
                    "
                  ></span>
                </div>
                <div class="review-field">
                  <span>{{localize('support_type')}}:</span>
                  <span v-text="fetchLabel(order.Order.MguideSupportType, supportTypes)"></span>
                </div>
                <div class="review-field">
                  <span>{{localize('fixation_pins')}}:</span>
                  <span v-text="getFixationPinsText()"></span>
                </div>
                <div
                  v-if="
                    order.OrderProstheticSolutionIDs &&
                      order.OrderProstheticSolutionIDs.length
                  "
                  class="review-field"
                >
                  <span> {{localize('planned_prosthtic_otpions')}} </span>
                  <ul>
                    <li
                      v-for="option in filteredProstheticSolutionTypes"
                      :key="option.id"
                      class=""
                    >
                      <span v-text="localize(option.name)"></span>                    
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade-slide" mode="out-in" appear>
          <div
            v-if="wizard.activeStep === 4 && mode === 'create'"
            key="form-agree"
            class="order-form--agree pl-l py-3xl"
          >
            <div class="check-group">
              <form-field
                :locale="locale"
                class="flex"
                field-type="checkbox"
                v-bind:label="getAgreeLinkText"
                v-model="terms.serviceAgree"
                external-label
              ></form-field>
              <form-field
                :locale="locale"
                class="flex"
                field-type="checkbox"
                v-bind:label="localize('an_order_of_this_service')"
                v-model="terms.collectingAgree"
                required
                external-label
              ></form-field>
            </div>
          </div>
        </transition>
      </div>
    </template>
    <a
      slot="wizard-links"
      v-if="$device !== 'mobile' && !isMcenter && !isDistributor"
      target="_blank"
      class="out-link inline-flex align-center justify-center line-1 mb-l inline-block"
      href="https://youtu.be/zyUEpFSHP1o"
    >
      <i class="fal fa-play-circle"></i>
      <span> {{localize('howtovideo_new_order')}} </span>
    </a>
  </wizard-wrap>
</template>

<script>
import { storage } from "@/utils";

import { mask } from "vue-the-mask";

// import moment from "moment";

import OrderPlan  from "@/components/OrderPlan.vue";
import ErrMsg     from "@/components/ErrMsg.vue";

import WizardWrap from "@/components/WizardWrap.vue";
import WizardNav from "@/components/WizardNav.vue";

import FragmentedField from "@/components/FragmentedField.vue";

import TeethChart from "@/components/TeethChart.vue";
import Uploader from "@/components/Uploader.vue";
// temp
// import { test_data, order_data } from "@/data";
import { mapGetters, mapActions, mapState } from "vuex";

const moment = require("moment-business-days");
// console.log("moment: ", moment());

export default {
  name: "OrderForm",
  directives: {mask},
  components:{OrderPlan},
  data() {
    return {
      isCoreFileInfoOpen:false,
      tmpSurgicalSets:[],
      tmpSurgicalSetsNos:'',
      // Toggle at every step for validations...
      solicitNextStep: false,

      orderPlan:-1,
      LiabilityExpandText:false,
      ProLiabilityInfoOpen:false, //show popup with info 
      proCheck1:false,
      proCheck2:false,
      proOrderNotesValid:true,

      // Manually trigger recomputation relating to teeth...
      teethUpdateTrigger: -1,
      loading: false,
      mode: "create",
      supportTypes: [
        {
          id: 0,
          name: "Tooth-supported"
        },
        {
          id: 1,
          name: "Mucosa-supported"
        }
      ],
      patientIdFragments: [
        {
          id: "firstName",
          type: "text",
          length: 1,
          placeholder: "F",
          mask: "A"
        },
        {
          id: "lastName",
          type: "text",
          length: 1,
          placeholder: "L",
          mask: "A"
        },
        {
          id: "day",
          type: "number",
          length: 2,
          placeholder: "DD",
          mask: "##",
          validation: new RegExp("^([0-2][0-9]|3[0-1])$"),
          validationMsg: this.localize('valid_format')+" : DD (01-31)"
        },
        {
          id: "month",
          type: "number",
          length: 2,
          placeholder: "MM",
          mask: "##",
          validation: new RegExp("^(0[1-9]|1[0-2])$"),
          validationMsg: this.localize('valid_format')+" : MM (01-12)"
        },
        {
          id: "year",
          type: "number",
          length: 4,
          placeholder: "YYYY",
          mask: "####",
          validation: new RegExp("^(19[0-9]{2}|20[0-1][0-9]|2020)$"),
          validationMsg: this.localize('valid_format')+" : YYYY (1900-2020)"
        }
      ],
      wizard: {
        totalSteps: 4,
        activeStep: 0,
        steps: [
          {
            label: "Information",
            hasSteps: [0],
            size: "sm"
          },
          {
            label: "Clinical Indications",
            hasSteps: [1]
          },
          {
            label: "Upload Data",
            hasSteps: [2]
          },
          {
            label: "Additional Information",
            hasSteps: [3]
          },
          {
            label: "Case Review",
            hasSteps: [4]
          }
        ]
      },
      teeth: {
        method: 0,
        selected: [],
        hasDigital: false,
        hasStoneModel: false,
        has3rdParty: false,
        hasImpressions: false
      },
      implantLocationDefaultObj: {},
      mediaFileDefaultObj: {},
      terms: {
        serviceAgree: false,
        collectingAgree: false
      },
      order: {}
    };
  },
  components: {
    WizardWrap,
    WizardNav,
    FragmentedField,
    TeethChart,
    Uploader,
    ErrMsg
  },
  // updated() {
  //   console.log("ORDER FORM COMPONENT UDPATED");
  // },
  created()
  {

  },
  mounted() {

    var vm = this;
    setTimeout(() => {
      vm.initUi(); //Delay for lables translations
    }, 500);

    //alert(this.orderUser.IsProUser);



console.log("moment: ", moment);
    console.log("mounted!!! oRDERFORM>>", this.orderId);
    if (this.orderId) {
      // UPDATE MODE OF EXISTING ORDER
      let orderOptions = storage.get("MFLOW__orderOptions", localStorage);
      if (!orderOptions) {
        this.initOrder(this);
      } else {
        this.initOrderOptions(JSON.parse(orderOptions));
      }
      this.initUpdateOrder();
    } else {
      this.initOrder(this);
    }
  },
  watch: {
      locale: 
      {
          handler: function(newValue) {
            //alert("newValue="+newValue);
            this.initUi();
          },
          deep: true
      },
    "proCheck1"()
    {
      this.checkProChecks();
    },
    "proCheck2"()
    {
      this.checkProChecks();
    },
    "order.Order.IsProOrder"()
    {
      //THIS IS TO PASS THE STEP OF FILES VALIDATION IN CASE OF PRO ORDER:
      if(this.order.User.IsProUser===true)
      {
        if(this.order.Order.IsProOrder===true)
        {
          this.teeth.hasDigital=false;
          this.teeth.hasStoneModel=true;
          if(this.order.Order.MlabStoneModelTrackingNumber==null || 
              this.order.Order.MlabStoneModelTrackingNumber.length==0)
          {
              this.order.Order.MlabStoneModelTrackingNumber="0";
          }
        }else{
          if(this.isNewOrder)
          {
            this.teeth.hasDigital=false;
            this.teeth.hasStoneModel=false;
            this.order.Order.MlabStoneModelTrackingNumber="";
          }
          else
          {
            //edit old order mode
            if(this.hasMediaFiles){
              this.teeth.hasDigital=true;
            }
          }


        }
      }

    },
    hasUploadCheck() {
      this.updateValidHash("uploadCheck", this.hasUploadCheck);
    },
    "order.Order.Actual_implant_date": _.debounce(function() {
      if (_.isDate(this.order.Order.Actual_implant_date)) {
        this.order.Order.Actual_implant_date.setHours(12);
      }
    }, 500),
    "teeth.has3rdParty"() {
      if (this.teeth.has3rdParty) {
        this.updateValidHash("File3dTypeID", !!this.order.Order.File3dTypeID);
      } else {
        this.removeFromValidHash("File3dTypeID");
      }
    },
    "wizard.activeStep"() {
      if (this.wizard.activeStep === 1) {
        this.updateValidHash(
          "MguideSupportType",
          !!(
            !_.isNull(this.order.Order.MguideSupportType) &&
            this.order.Order.MguideSupportType > -1
          )
        );
        this.updateValidHash(
          "AdditionalIndicationsTypeID",
          !!this.order.Order.AdditionalIndicationsTypeID
        );
      } else if (this.wizard.activeStep === 2) 
      {
        this.updateValidHash("uploadCheck", this.hasUploadCheck);
      }
    },
    orderData() {
      if (!this.orderId) {
        this.order = this.orderData;
        this.implantLocationDefaultObj = JSON.parse(
          JSON.stringify(this.orderData.ImplantLocations[0])
        );
        this.mediaFileDefaultObj = JSON.parse(
          JSON.stringify(this.orderData.MediaFiles[0])
        );
        this.orderData.MediaFiles = [];
        this.orderData.ImplantLocations = [];
      }
    }
  },
  methods: {
    ...mapActions(["initOrder", "initOrderOptions", "submitOrder"]),
    initUi()
    {
      //Wizard steps lables
      this.wizard.steps[0].label = "information";//this.localize('information');
      this.wizard.steps[1].label = "clinical_indications";this.localize('clinical_indications');
      this.wizard.steps[2].label = "upload_data";this.localize('upload_data');
      this.wizard.steps[3].label = "additional_info";this.localize('additional_info');
      this.wizard.steps[4].label = "case_review";this.localize('case_review');

      //var vf = this.localize('valid_format');
      this.patientIdFragments[2].validationMsg = this.localize('valid_format')+": DD (01-31)";
      this.patientIdFragments[3].validationMsg = this.localize('valid_format')+": MM (01-12)"
      this.patientIdFragments[4].validationMsg = this.localize('valid_format')+": YYYY (1900-2020)"

    },
    openCoreFileInfo()
    {
      this.isCoreFileInfoOpen = !this.isCoreFileInfoOpen;
    },
    checkProChecks()
    {
       if(this.proCheck1===true && this.proCheck2===true) 
       {
          this.proOrderNotesValid=true;
       }
    },
    isUseCoreFile()
    {
      var order = this.order.Order;
      return order.UseCoreFile==true ? true : false;

    },
    getFixationPinsText()
    {
      var order = this.order.Order;
      if(order.FixationPins && order.FixationPins==true){
          return this.localize('yes');
      }else{
          return this.localize('no');
      }
    },
    // For a single field >> is invalid?
    isInvalid(_key) {
      return this.solicitNextStep && this.validHash[_key] === false;
    },
    //<!-- :href="getFileLink(file)" :href="`${serverAPI}mflow/OrderFileDownload/${file.FileID}`" -->
    getFileLink(file)
    {
      let fileURL ='';
      if(file.FileProccessingTypeId==1){
        fileURL = this.serverAPI+"mflow/OrderFileDownload/"+file.FileID;
      }
      return fileURL;
    },
    fetchLabel(id, list, label = "name", identifier = "id") {
      // return 'haha'
      let _find = _.find(list, item => item[identifier] === id);
      if (_find) {
        return this.localize(_find[label]);
      }
      return "";
    },
    fetchDiameterTypes(implant_id) {
      let list = this.orderOptions.DiametersTypes;
      if (implant_id == 11) 
      {
        //LYNX 3.3 3.5 4.2 5 
        const filtered = _.filter(list, obj => /^[1846]$/.test(obj.id));
        return _.sortBy(filtered, obj => Number(obj.name));
      }
      if (implant_id !== 3 && implant_id !== 8) {
        // NOT V3 or V3B
        return _.filter(list, obj => /^[1246]$/.test(obj.id));
      }
      return _.filter(list, obj => /^[1356]$/.test(obj.id));
    },
    fetchLengthTypes(diameter_id, implant_id) 
    {
      //length table
      //id  //name  
      //1   6mm
      //2   8mm
      //3   10mm
      //4   11.5mm
      //5   13mm
      //6   16mm

      //diameters
      //id  name
      //1   3.30
      //2   3.75
      //3   3.90
      //4   4.20
      //5   4.30
      //6   5
      //7   6
      //8   3.75
      
      let list = this.orderOptions.LengthTypes;
        if (implant_id == 11) 
        {
          if(diameter_id==1){return _.filter(list, obj => /^[3456]$/.test(obj.id))}//3.30D=>10,11.5,13,16
          if(diameter_id==8){return _.filter(list, obj => /^[23456]$/.test(obj.id))}//3.75D=>8,10,11.5,13,16
          return list;//return full list 6,8,10,11.5,13,16
        }

      if (diameter_id == 1) {
        // 3.30
        return _.filter(list, obj => /^[3456]$/.test(obj.id));
      } else if (diameter_id === 2) {
        // 3.75
        if (implant_id !== 5) {
          // NOT LANCE+
          return _.filter(list, obj => /^[23456]$/.test(obj.id));
        }
        return _.filter(list, obj => /^[3456]$/.test(obj.id));
      } else if (diameter_id === 3) {
        // 3.9 << only V3

        return _.filter(list, obj => /^[23456]$/.test(obj.id));
      } else if (/^[46]$/.test(diameter_id)) {
        // 4.2, 5
        if (/^[14]$/.test(implant_id)) {
          // SEVEN & M4
          return list;
        }
        return _.filter(list, obj => /^[23456]$/.test(obj.id));
      } else if (diameter_id === 5) {
        // 4.3 << only V3
        return _.filter(list, obj => /^[23456]$/.test(obj.id));
      } else if (diameter_id === 6) {
        // 4.3 << only V3
        return _.filter(list, obj => /^[23456]$/.test(obj.id));
      }
      return list;
    },
    fetchImplantLocationFields(implant) {
      console.log("fetchImplantLocationFields: ", implant);
      let implantTypeId = implant ? parseInt(implant.ToothImplantType) : null;
      return [
        {
          id: 1,
          _prop: "num",
          enumerable: true,
          label: this.localize("Tooth"),
          type: "text",
          disabled: true,
          background: "blue",
          color: "gray-0",
          labelColor: "gray-6",
          circle: true,
          css: "mini",
          externalLabel: true
        },
        {
          id: 2,
          _prop: "ToothImplantType",
          label: this.localize("Implant Type"),
          type: "select",
          css: "longer",
          options: this.orderOptions.ImplantTypes,
          rounded: true,
          externalLabel: true,
          required: true
        },
        {
          id: 3,
          _prop: "ToothDiameterType",
          label: this.localize("Diameter"),
          type: "select",
          requires: "ToothImplantType",
          options: implant
            ? this.fetchDiameterTypes(implantTypeId)
            : this.orderOptions.DiameterTypes,
          rounded: true,
          externalLabel: true
        },
        {
          id: 4,
          _prop: "ToothLengthType",
          label: this.localize("Length"),
          type: "select",
          requires: "ToothDiameterType",
          options: implant
            ? this.fetchLengthTypes(implant.ToothDiameterType, implantTypeId)
            : this.orderOptions.LengthTypes,
          rounded: true,
          externalLabel: true
        }
      ];
    },
    toothUpdated(tooth) {
      // let locations = this.order.ImplantLocations;
      let selected = this.teeth.selected;
      let toothIndex = _.findIndex(selected, { id: tooth.id });
      // console.log(
      //   "TETH UPDATED > ",
      //   this.order.ImplantLocations,
      //   " >>> ",
      //   tooth,
      //   ">>>",
      //   toothIndex
      // );
      if (toothIndex > -1) {
        console.log("toothIndex: ", toothIndex);
        // let toothIndex = _.findIndex(locations, { ThoothID: tooth.id });
        if (tooth.opt) {
          // console.log("locations >>>>> ", locations);
          this.teethUpdateTrigger = new Date().getTime();
          selected[toothIndex].opt = tooth.opt;
          this.order.ImplantLocations[toothIndex].TreatTypeID = tooth.opt;
        } else {
          selected.splice(toothIndex, 1);
          this.order.ImplantLocations.splice(toothIndex, 1);
        }
      } else {
        selected.push(tooth);
        this.order.ImplantLocations.push(tooth);
        console.log(
          "this.order.ImplantLocations: ",
          this.order.ImplantLocations
        );
        let i = this.order.ImplantLocations.length - 1;
        console.log("i: ", i);
        this.$set(this.order.ImplantLocations, i, tooth);
        this.order.ImplantLocations[i].TreatTypeID = tooth.opt;
        // selected.push(tooth);
        // locations[toothIndex].TreatTypeID = tooth.opt;
      }
    },
    updateImplantLocations(e, payload, tooth, i) {
      this.order.ImplantLocations[i] = payload;
    },
    fetchImplantIndex(tooth) {
      let i = _.findIndex(this.teeth.selected, { id: tooth.id });
      // console.log("implant index >", i);
      return i;
    },
    stepCallback(step, index) {
      let isStepBefore = this.wizard.activeStep > index;
      this.solicitNextStep = true;
      if (isStepBefore) {
        this.updateValidHash(false);
      }
      if (!this.formIsValid && !isStepBefore) {
        return;
      }
      this.updateValidHash(false);
      this.solicitNextStep = false;
      this.wizard.activeStep = index;
    },
    async submit(isDraft) {
      let vm = this;

      if (isDraft) {
        this.$set(this.order.Order, "IsDraft", true);
      } else {
        this.$set(this.order.Order, "IsDraft", false);
        if (
          this.mode !== "update" &&
          (!this.terms.serviceAgree || !this.terms.collectingAgree)
        ) {
          this.wizard.activeStep = 4;
          this.$toasted.show(
            this.localize('agree_to_our_terms'),
            //`To proceed, Please agree to our terms of service.`,
            {
              duration: null,
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "warning",
              theme: "outline",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              },
              action: {
                text: "Ok",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                }
              }
            }
          );
          this.loading = false;
          return false;
        }
      }
      let order = Object.assign({}, this.order);
      order.ImplantLocations = _.map(order.ImplantLocations, item => {
        let obj = _.clone(item);
        // console.log("1 OBJ><", obj);
        let defaultObj = _.clone(vm.implantLocationDefaultObj);
        // console.log("2 defaultObj><", defaultObj);
        return _.extend(defaultObj, obj);
      });
      // console.log("b4 submit> ", order);
      if (!this.order.Order.Order_date) {
        this.order.Order.Order_date = new Date();
      }
      // // return;
      // console.log("3 implantLocations>> ", JSON.stringify(implantLocations));

      // order.ImplantLocations = implantLocations;
      // return;
      let result = await this.submitOrder(JSON.stringify(order));
      this.loading = false;
      if (result) {
        // SAVE SUCCESS
        let msg =
          this.mode === "update"
            ? `Order ${this.orderId} has been updated`
            : "Your order has been created";
        this.$toasted.show(msg, {
          position: "bottom-center",
          // iconPack: "fontawesome",
          type: "success",
          theme: "bubble",
          icon: {
            name: "fal fa-save mr-xs"
          }
        });
        this.$router.push("/");
      }
    },

    async nextStep() {

      //VALIDATE STEP3 PRO ORDER / UPLOAD DATA
      //orderUser.IsProUser
      if(this.orderUser.IsProUser===true){
        if(this.wizard.activeStep === 2){
          if(this.orderPlan<0){
            alert("Please select a plan");return;
          }
          if(this.order.Order.IsProOrder){
            if(this.proCheck1==false || this.proCheck2==false){
              this.proOrderNotesValid=false;              
              return false;
            }
          }
        }
      }

      //dubixxx
      if(this.wizard.activeStep === 2){
        //if digital file is marked and the user
        //already uploaded the files then we dont need to validate 
        //the uploader inputs 
      }

      //wizard.activeStep === 2
      //order.Order.IsProOrder
      //proCheck1,proCheck2

      console.log("NEXT STEPO >> ", this.isLastStep);
      this.solicitNextStep = true;
      //alert("this.formIsValid="+this.formIsValid);

      if (!this.formIsValid) {
        return;
      }
      if (this.isLastStep) {
        this.loading = true;
        // console.log("submitOrder");
        this.submit();
      } else {
        this.solicitNextStep = false;
        this.updateValidHash(false);
        this.wizard.activeStep++;
      }
    },
    lastStep() {
      this.solicitNextStep = false;
      this.updateValidHash(false);
      this.wizard.activeStep--;
    },
    updateMethod(e) {
      // this.teeth.method = e;
      this.order.Order.IndicationsMethod = e;
    },
    parseToothNumber(tooth) {
      // Grab the Number by Method (ADA OR FDI)
      let method = this.order.Order.IndicationsMethod;
      let num = method === 1 ? "ADA" : "FDI";
      // console.log("PARSE TOOTH NUM:: TOOTH==", tooth);
      // console.log("PARSE TOOTH NUM:: NUM==", num);
      // console.log("PARSE TOOTH NUM:: METHOD==", method);
      // console.log("PARSE TOOTH NUM:: RESULT==", tooth[num]);
      return { ThoothID: tooth.id, num: tooth[num], TreatTypeID: tooth.opt };
    },
    fetchToothById(ToothID) {
      let ToothTableItems = this.orderOptions.ToothTableItems;
      let findTooth = _.find(ToothTableItems, { ToothID });
      // console.log("FIND TOOTH >> ", findTooth);
      return findTooth;
    },
    /*
      Paste relevantdata from 1 field-group
      to rest of enabled field-groups.
    */
    pasteDataToAll(e, targetProp) {
      let vm = this;
      console.log("e, targetProp: ", e, targetProp);
      let topaste = Object.assign({}, e);
      delete topaste.num;
      delete topaste.TreatTypeID;
      delete topaste.ThoothID;
      delete topaste.id;
      targetProp.forEach((item, i) => {
        if (item.TreatTypeID !== 1) {
          console.log("1 item: ", item);
          Object.assign(item, topaste);
          console.log("2 item: ", item);
          vm.$set(vm.order.ImplantLocations, i, item);
        }
      });
    },
    formatDate(date) {
      return moment(date).format("D/M/YYYY");
    },
    /*
      Update MediaFiles in JSON
      from <uploaders...
    */
    updateMediaFiles(files, remove) {
      console.log("remove: ", remove);
      let vm = this;
      console.log("updateMediaFiles files: ", files);

      let _files = _.map(files, (item, i) => {
        // let obj = Object.assign({}, vm.mediaFileDefaultObj);
        return _.merge(Object.assign({}, vm.mediaFileDefaultObj), files[i]);
      });
      console.log("_files: ", _files);

      // if (this.hasMediaFiles) {
      //   this.order.MediaFiles.push(..._files);
      // } else {

      let mediaFiles = this.order.MediaFiles;
      mediaFiles.push(..._files);
      console.log("mediaFiles: ", mediaFiles);
      this.$set(
        this.order,
        "MediaFiles",
        _.uniqBy(mediaFiles, "OriginFileName")
      );
      // }
    },
    removeMediaFile(OriginFileName) {
      console.log("OriginFileName: ", OriginFileName);
      let files = this.order.MediaFiles;
      console.log("1 files: ", files.length);
      let i = _.findIndex(this.order.MediaFiles, { OriginFileName });
      files.splice(i, 1);
      console.log("2 files: ", files.length);
      // _.remove(this.order.MediaFiles, { OriginFileName });
    },
    /*
      Updates the Prosthetic Solution IDs Array in JSON
    */
    updateSurgicalSetsObject()
    {
      //SurgicalSets string for object update
      let tempSetsList = '';
      let tempSetsNos = '';
      if(this.tmpSurgicalSets.length>0){
        for(let val of this.tmpSurgicalSets)
        {
          if(tempSetsList.length>0){
            tempSetsList=tempSetsList+",";
            tempSetsNos = tempSetsNos+",";
          }
          tempSetsList=tempSetsList+val;

          //todo; add the kit catalog_no to the array (to display in the order summary)
          let kitsArray = this.orderOptions.SurgicalSetTypes;
          //let findKitItem = _.find(kitsArray, item => item[Id] === val);          
          let kitIndex = _.findIndex(kitsArray, function(o) { return o.Id == val; });
          let findKitItem = kitsArray[kitIndex];
          //alert("findKitItem.CatNo="+findKitItem.CatNo);
          tempSetsNos=tempSetsNos+findKitItem.CatNo;//<< this will add the id and not the no          
        }        
      }
      this.tmpSurgicalSetsNos = tempSetsNos;
      this.$set(this.order.Order, "SurgicalSets", tempSetsList);
    },
    findSetIndex(setID){      
      return this.tmpSurgicalSets.indexOf(setID);
    },
    updateSurgicalSetTypeIDs(setID){
      let i = this.findSetIndex(setID);
      if (i > -1) {
        this.tmpSurgicalSets.splice(i, 1);//remove it from the array
        //alert("removed setID="+setID+" array length="+this.tmpSurgicalSets.length);
      } else {        
        this.tmpSurgicalSets.push(setID);//add it to the array
        //alert("added setID="+setID+" array length="+this.tmpSurgicalSets.length);
      }
      this.updateSurgicalSetsObject();
    },
    updateProstheticSolutionIDs(option) {
      let solutions = this.order.OrderProstheticSolutionIDs,
        solution_id = option.id,
        order_id = this.orderId;
      let i = this.solutionIndex(option);
      if (i > -1) {
        solutions.splice(i, 1);
      } else {
        solutions.push({
          id: -1,
          solution_id,
          order_id
        });
      }
    },
    solutionIndex(option) {
      return _.findIndex(this.order.OrderProstheticSolutionIDs, {
        solution_id: option.id
      });
    },

    initUpdateOrder() {
      let vm = this;
      this.mode = "update";

      var postURL = `${SERVER_API[ENV]}mflow/OrderMguide/${this.orderId}`;
      fetch(postURL, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "pragma": "no-cache",
          "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          t: this.userToken,
          u: this.userID
        }
      })
        .then(res => res.json())
        .then(res => {
          console.log("RESLL ", res);
          if (typeof res === "string" && res.indexOf("Denied") > -1) {
            vm.$toasted.show("Wrong order.. sorry about that.", {
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "warning",
              theme: "bubble",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              }
            });
            vm.$router.push("/");
          } else {
            vm.setOrder(res.Order);
          }
        })
        .catch(err => err);
    },
    setOrder(order) {
      this.order = order;
      // this.teeth.method = order.Order.IndicationsMethod || 1;
      // console.log("has selected > ", this.hasSelectedTeeth);

      this.order.OrderProstheticSolutionIDs = _.filter(
        this.order.OrderProstheticSolutionIDs,
        item => !!item.solution_id
      );
      if (this.hasMediaFiles) {
        this.mediaFileDefaultObj = _.extend(_.clone(order.MediaFiles[0]), {
          FileID: -1
        });
      }
      if (this.hasSelectedTeeth) {
        this.implantLocationDefaultObj = _.extend(
          _.clone(order.ImplantLocations[0]),
          {
            id: -1
          }
        );
        this.teeth.selected = this.order.ImplantLocations.map(tooth => {
          let t = this.fetchToothById(tooth.ThoothID);
          let ADA, FDI;
          if (t) {
            ADA = t.ToothNumberADA;
            FDI = t.ToothNumberFDI;
          }
          return {
            ADA,
            FDI,
            id: tooth.ThoothID,
            opt: tooth.TreatTypeID
          };
        });
      }
      //alert("this.hasMediaFiles="+this.hasMediaFiles);
      if (this.hasMediaFiles) {
        this.teeth.hasDigital = true;
      }
      if (this.order.Order.MlabStoneModelTrackingNumber) {
        this.teeth.hasStoneModel = true;
      }
      if (this.order.Order.MlabImpressionTrackingNumber) {
        this.teeth.hasImpressions = true;
      }
      if (this.order.Order.File3dTypeID) {
        this.teeth.has3rdParty = true;
      }
      if (this.order.Order.IsProOrder===true) {
          this.orderPlan = 1;
        }else{
          this.orderPlan = 2;
      }        
      //this.teeth.hasDigital=true;//
    }
  },
  computed: {
    //this.localize('information')
      step_information()
      {
        return this.localize('information');
      },
      getLangDir()
      {
        return this.locale == 'HE' ? 'rtl' : '';
      },
      
    ...mapState({
      locale: state => state.locale,
      orderData: state => state.order.data,
      orderOptions: state => state.order.options,
      $device: state => state.$device
    }),
    ...mapGetters(["userToken", "userID", "isDistributor", "isMcenter"]),
    //? getClinicName //`${orderUser.ClinicName} (${orderUser.ClinicBranch})`
    getDoctorName(){
        return this.orderUser.FirstName+ ' '+this.orderUser.LastName;
    },
    getClinicName(){
      let cname = this.orderUser.ClinicName;//
      if(this.orderUser.ClinicBranch !=null && this.orderUser.ClinicBranch.length>0){
        cname=cname+ ' ('+this.orderUser.ClinicBranch+')';
      }
      return cname
    },
    serverAPI() {
      return SERVER_API[ENV];
    },
    getNextStepLabel()
    {
      let labelName =  this.isLastStep ? `${this.mode === 'create' ? 'Create' : 'Update'} Order` : 'Next';
      return this.localize(labelName);
    },
    isUSA() {
      return this.orderUser.Country === "226";
    },
    isIsrael() {
      return this.orderUser.Country === "104";
    },

    getAgreeLinkText()
    {
      let linkCode = "<a class='inline-block mx-xs' href='/docs/MGUIDE_terms-of-service.pdf' target='_blank'>"+ this.localize('i_agree_to_the_terms') +"</a>";
      return linkCode;
    },
    minImplantDate() {
      return new Date(
        this.isUSA
          ? moment(new Date()).add(1, "week")
          : moment(new Date()).businessAdd(10)
      );
    },

    hasUploadCheck() {
      return (
        this.teeth.hasStoneModel ||
        this.teeth.hasImpressions ||
        this.teeth.hasDigital ||
        this.teeth.has3rdParty
      );
    },
    hasSelectedTeeth() {
      return !!(
        this.order.ImplantLocations &&
        this.order.ImplantLocations.length &&
        this.order.ImplantLocations[0].ThoothID
      );
    },
    filteredProstheticSolutionTypes() {
      let d = _.map(this.order.OrderProstheticSolutionIDs, "solution_id");
      // console.log("d >> ", d);
      return _.filter(this.orderOptions.ProstheticSolutionTypes, opt => {
        return d.indexOf(opt.id) > -1;
      });
    },
    selectedTeethForImplant() {
      this.teethUpdateTrigger;
      let s = this.teeth.selected;
      if (s.length) {
        return _.filter(s, tooth => tooth.opt !== 1);
      }
      return s;
    },
    // hasFiles() {
    //   return this.order.MediaFiles && this.order.MediaFiles[0].FileID;
    // },
    orderId() {
      return parseInt(this.$route.params.orderId);
    },
    orderUser() {
      let order = _.keys(this.orderData).length ? this.orderData : this.order;
      if (order.User) {
        return order.User;
      }
      return false;
    },
    dentistList() {
      let order = _.keys(this.orderData).length ? this.orderData : this.order;
      if (order && order.Surgeons) {
        return _.map(_.filter(order.Surgeons, "active"), s => {
          return {
            id: s.id,
            name: s.first_name + " " + s.last_name
          };
        });
      }
      return null;
    },
    isNewOrder()
    {
      return this.order.Order.WO_ID == -1 ? true : false;
    },
    hasMediaFiles() {
      let files = this.order.MediaFiles;
      if (files && files.length) {
        return !!files[0].FileName;
      }
      return false;
    },
    hasBlockedFiles()
    {
      let files = this.order.MediaFiles;
      for(var i=0;i<files.length;i++)
      {
        let file = files[i];
        if(file.FileProccessingTypeId==2){
          return true;
        }
      }
      return false;
    },
    hasStlFile()
    {
      //return true;//
      let files = this.order.MediaFiles;
      if (files && files.length) {
        let names = _.map(files, "OriginFileName");
        let j = names.join(" ");
        return /(\.stl|\.ply)/g.test(j);
        //return /(\.stl)/g.test(j);
      }
      return false;
    },
    hasCBCTFile() {
      //return true;//
      let files = this.order.MediaFiles;
      if (files && files.length) {
        let names = _.map(files, "OriginFileName");
        let j = names.join(" ");
        return /(\.zip|\.rar)/g.test(j);
      }
      return false;
    },
    isLastStep() {
      return this.wizard.activeStep === this.wizard.totalSteps;
    },
    isClinic() {
      if (this.orderUser) {
        return this.orderUser.IsClinic;
      }
      return false;
    },

    implantLocationFields() {
      return [
        {
          id: 1,
          _prop: "num",
          enumerable: true,
          label: this.localize("Tooth"),
          type: "text",
          disabled: true,
          background: "blue",
          color: "gray-0",
          labelColor: "gray-6",
          circle: true,
          css: "mini",
          externalLabel: true
        },
        {
          id: 2,
          _prop: "ToothImplantType",
          label: this.localize("Implant Type"),
          type: "select",
          css: "longer",
          options: this.orderOptions.ImplantTypes,
          rounded: true,
          externalLabel: true,
          required: true
        },
        {
          id: 3,
          _prop: "ToothDiameterType",
          label: "Diameter",
          type: "select",
          requires: "ToothImplantType",
          options: this.orderOptions.DiametersTypes,
          rounded: true,
          externalLabel: true
        },
        {
          id: 4,
          _prop: "ToothLengthType",
          label: "Length",
          type: "select",
          requires: "ToothDiameterType",
          options: this.orderOptions.LengthTypes,
          rounded: true,
          externalLabel: true
        }
      ];
    }
  }
};
</script>
<style>  
  .checkbox .coreFileCheck
  {
      float:left;position:relative;left:-3px;
  }
  .checkbox .coreFileText
  {
      float:left;padding-left:5px;width:70%;
  }
  .checkbox.rtl .coreFileCheck
  {
      float:right;position:relative;right:-3px;
  }
  .checkbox.rtl .coreFileText
  {
      float:right;padding-right:5px;width:70%;
  }


  .checkbox-trig.rtl span:before,
  .check-group.rtl span:before {
    margin-right: 0;
    margin-left: 0.25rem;
  }
  
  .blockedFilesNote
  {
    clear: both;
    padding-bottom: 15px;
    font-size: 12px;
  }

  .filesItems li.process_type_2 a
  {
    color:red;
  }
  .filesItems li
  {
    width: 290px;
    position: relative;
  }
  .filesItems li .removeFile
  {
    cursor: pointer;
    position: absolute;
    right: 0px;
    background-color: #ddd;
    color:#fff;
    width: 20px;height: 20px;
    border-radius: 20px;
    display:inline-flex;
    margin-left: 10px;
    font-size: 12px;
    align-items: center;
    text-align: center;
    align-content: center;
  }
  .filesItems li .removeFile i
  {
    margin: auto !important; 
  }
  .filesItems li .removeFile:hover 
  {
    background-color: red;
  }
  .filesItems li .removeFile:hover i
  {
    color:#fff;
  }
  .blockedFile
  {
    color:red;
  }
  .review-field.corefile b
  {
    font-weight: inherit;
  }
  .wiz-review.rtl .review-field span:first-child
  {
      margin-left: 0.25rem;
      margin-right:0px

  }

</style>
<style lang="stylus" scoped>
.hiddenSection
  display none
.ProOrderTerms
  list-style disc
  li
    list-style disc
    margin-left 20px
    padding-top 5px
.fixation
  border-top solid 1px #ccc
  width 100%
  padding-top 10px
  margin-top 3px
.form-field
  align-items center
  marg('m', bottom)
  .form-part--field
    padding-bottom 0
  *
    flex 1
  label
    font-weight 600
    font-size 14px
    color gray_8
    flex none
    marg('s', right)
    &.rtl
      marg('s', left)
  &:at-least(2)
    label
      min-width 120px
  & > :last-child
    color gray_6
</style>
<style lang="stylus" scoped>
.order-form
  &--agree
    padding-right 200px
  &--panels
    border-bottom 1px solid gray_6
.panel
  &--title
    background blue_0
    height 68px
    color gray_9
    font-size 18px
    font-weight 600
    _flex(row, wrap, center, space-between)
    transition background 0.6s ease-out
    cursor pointer
    +desktop()
      &:hover
        background blue_3
    i
      color #fff
      font-size 30px
      transition transform 0.3s ease-out, color 0.3s ease-out, padding-bottom 0.3 ease-out
      will-change transform, color, padding-bottom
  &--content
    _flex(row, wrap, stretch, space-between)
    max-height 100vh
    padding-bottom 30px
    overflow hidden
    transition max-height 0.6s ease-out
    &__half
      flex 0 0 50%
      position relative
      .btn-group.bottom
        position absolute
        width 100%
        bottom 0
      &:first-child
        border-right 1px solid gray_3
        padding-right 40px
      &:last-child
        margin-left 40px
        flex 0 0 calc(50% - 40px)
  &.collapsed
    .panel--title
      background gray_2
      margin-bottom 2px
      box-shadow 1px 1px 0px 0px rgba(0,0,0,0.15)
      i
        transform rotate(-90deg)
        color gray_6
    .panel--content
      max-height 0px
      padding-bottom 0

.bb
  border-bottom 1px solid blue_brand
  pad('m', bottom)

.info-blocks
  width 80%
  max-width 450px
  &--item
    border 1px solid gray_4
    border-radius 6px
    _flex(row, nowrap, center, flex-start)
    pad('m', y)
    pad('xs', right)
    pad('m', left)
    marg('xl', bottom)
    span
      font-size 13px
    &:before
      color #55ABB7
      font-size 24px
      font-weight 600
      margin-right 20px
    &:nth-child(1)
      &:before
        content 'A'
    &:nth-child(2)
      &:before
        content 'B'
    &:nth-child(3)
      &:before
        content 'C'

.link-list li
  margin-bottom 10px
  _flex(row, nowrap, baseline, flex-start )
  i
    font-size 12px
</style>

<!-- plan styles -->
<style>
  .useCoreFileText {
    font-size: 15px;
  }
  .useCoreFileText b{
    font-weight: 700 !important;
  }
</style>

<style scoped>
  .CoreFileInfo
  {
    position:absolute;
    padding:34px 20px;
    color:#fff;
    background-color: #1178be;
    width:300px;
    border-radius: 5px;
    bottom: 15px;
    left: 3px;
    font-size: 14px;
    font-weight: 500;
    pointer-events:none;
    opacity: 0;
    transition: all ease 0.3s;
  }
  .CoreFileInfo.open
  {
    opacity: 1;
    pointer-events: all;
  }
  .CoreFileInfo i
  {
    position:absolute;
    top: 12px;
    right: 12px;
    font-size: 16px;
    opacity: 0.5;
    font-weight: 100;
  }
  .CoreFileInfo i:hover
  {
    opacity: 1;
  }
  
  .SurgicalSetTypes
  {
    padding-bottom:15px;
  }
  .ProLiabilityInfo
  {
    position: fixed;top: 0px;left: 0px;
    width: 100%;
    height: 100%;
    background-color:rgba(255,255,255,0.95);
    display: block;
    float: left;
    z-index: 1000;
  }
  .ProLiabilityInfo .InnerText
  {    
    color:#000;
    font-weight: 300;
    position: absolute;
    max-width: 700px;margin: auto;
    top:50%;left: 50%;
    transform:translate(-50%,-50%);
  }
  .ProLiabilityInfo .xClose
  {
    position: absolute;right: 20%;top: 150px;cursor: pointer;
  }
  .ProLiabilityInfo .xClose i
  {
    font-size: 40px;font-weight: 100;
  }

  .planSelector
  {
    clear: both;width: 100%;min-height: 300px;    
  }
  .planGrid
  {
    margin: auto;display: table;width: 600px;
  }
  .planGrid tr td
  {
    padding: 10px 20px;font-size: 12px;vertical-align: middle;
  }
  .planGrid tr td i
  {
    color:#1178be;
  }


  /* Plan1 (Pro) 2nd Col higlight */
  .planGrid.plan1 tr td:nth-child(2){
    background-color: #1178be;color:#fff;
  }
  .planGrid.plan1 tr td:nth-child(2) i{
    background-color: #1178be;color:#fff;
  }
  .planGrid.plan1 tr td.plan1Select{
    opacity: 0;pointer-events:none;
  }
  /* Plan2 (Full Service) 3nd Col higlight */
  .planGrid.plan2 tr td:nth-child(3){
    background-color: #1178be;color:#fff;
  }
  .planGrid.plan2 tr td:nth-child(3) i{
    background-color: #1178be;color:#fff;
  }
  .planGrid.plan2 tr td.plan2Select{
    opacity: 0;pointer-events:none;
  }

  
  .planGrid tr:nth-child(1) td
  {
    font-size: 16px;padding: 20px 20px;
  }
  .planGrid tr td:nth-child(2),
  .planGrid tr td:nth-child(3)
  {
    text-align: center;
  }

  .planGrid tr .plTransCell
  {
    background-color: transparent;
  }

  .planGrid tr td:nth-child(1)
  {
    width: 50%;
  }
  .planGrid tr td:nth-child(2)
  {
    width: 25%;background-color: #f5f5f5;
  }
  .planGrid tr td:nth-child(3)
  {
    width: 25%;background-color: #f5f5f5;
  }




  .planCol
  {
    display: inline;display: table-cell;margin: 1px; border: solid 1px #fff; 
  }
  .planCol:nth-child(1)
  {
    width: 50%;
  }
  .planCol:nth-child(2)
  {
    background-color: #1178be;
    width: 25%;
  }
  .planCol:nth-child(3)
  {
    width: 25%;
    background-color: #1178be;
  }
  .planCol .pc
  {
    vertical-align: middle;
    padding: 15px 15px;
    border: solid 1px #fff;
    font-size: 12px;
  }
  .planCol .pc:nth-child(1)
  {
    font-size: 20px;
  }
  .plFeatureName
  {
    background-color: #f3faff;        
  }
  .btnSelectPlan
  {
    font-size: 14px;
    padding: 5px 20px !important;
    background-color: transparent;
  }

  .planCol .pc.featureTop
  {
    background-color: #f3faff;  
    text-align: center;  
  }
  .planCol .pc.featureVal
  {
    background-color: #f3faff;  
    text-align: center;  
    line-height: 14px;
    font-size: 14px;
  }


  .proOrderInfo
  {
    margin: 50px auto;
    padding: 30px 0px;
    margin: auto;
    width: 600px;    
  }
  .proOrderInfo span{
    font-weight: 400;  
  }
  .proOrderInfo ul{
    list-style-type: disc;
    padding-top:10px;
  }
  .proOrderInfo ul li{
    font-size: 14px;
    list-style-type: disc;
    margin-left:20px;
  }
  .msoft_input
  {
    max-width:250px;
    margin-top:10px;
  }
  .boxErr
  {
    background-color:#f9e4e4 !important;
  }
  .proOrderNotes
  {
    transition: ease-in all 0.3s;
    background-color: #fafafa;
    width: 600px;
    margin: 50px auto;
    padding: 30px;
  }
  .proOrderNotes .cbItem
  {
      display: flex;
      align-items: top;
  }
  .proOrderNotes .cbItem input[type="checkbox"] {
      margin-top: 13px;
  }
  .proOrderNotes .cbItem p {
      padding: 10px 10px;
      transition: background 0.2s;
      flex: 1;
      font-family:'helvetica neue';
      font-size: 14px;
      font-weight: 200;
    }
  
</style>
